import { cacheDom } from '../utils/QuerySelectors.js'
import { makeRequest } from '../utils/Storefront.js'
import { getStoreQuery, formatStoreData } from '../utils/Store.js'
import Fuse from 'fuse.js'

const dom = {}
const qs = {
  section: 'data-section-type="eyewear-stores-list"',
  reverseSection: 'data-section-type="stores-list"',
  swiper: 'data-eyewear-featured-stores',
  input: 'data-store-zipcode',
  listWrap: 'data-stores-list-wrap',
  hero: 'data-hero-image',
  regionSelectWrap: 'data-region-select-wrap',
  regionSelector: 'data-region-selector',
  list: 'data-eyewear-stores-list',
}

const qsAll = {
  current: 'data-store-current',
  viewAll: 'data-all-stores',
}
const fuseOptions = {
  includeScore: true,
  keys: [
    {
      name: 'addressForSearch',
      weight: 1,
    },
    {
      name: 'address',
      weight: 1,
    },
    {
      name: 'zipcode',
      weight: 2,
    },
    {
      name: 'city',
      weight: 3,
    },
    {
      name: 'country',
      weight: 4,
    },
    {
      name: 'region',
      weight: 5,
    },
  ],
  // useExtendedSearch: true,
}
// Country name values should be matched in the metaobject country values.
const state = {
  fuse: null,
  countries: {
    US: 'United States',
    CA: 'Canada',
    CN: 'China, Mainland',
    IT: 'Italy',
    JP: 'Japan',
    KR: 'Korea, Republic of',
    HK: 'Hong Kong SAR',
    PT: 'Portugal',
    TW: 'Taiwan Region',
    UK: 'United Kingdom',
    FR: 'France',
    RU: 'Russian Federation',
    AU: 'Australia',
    MO: 'Macau SAR',
    CH: 'Switzerland',
    DE: 'Germany',
    TH: 'Thailand',
    AE: 'U.A.E.',
    UA: 'Ukraine',
    AT: 'Austria',
    BE: 'Belgium',
    DK: 'Denmark',
    GR: 'Greece',
    KW: 'Kuwait',
    LB: 'Lebanon',
    MG: 'Madagascar',
    MY: 'Malaysia',
    MX: 'Mexico',
    NL: 'Netherlands',
    PH: 'Philippines',
    SK: 'Slovakia',
    ES: 'Spain',
    SE: 'Sweden',
    TK: 'Tokelau',
  },
}

const getStores = () => {
  let query = getStoreQuery('eyewear_store', 250)
  window.eyewearStoresList = []
  makeRequest((results) => {
    window.eyewearStoresList = window.eyewearStoresList.concat(results.data?.metaobjects?.edges?.map((edge) => formatStoreData('eyewear_store', edge)))
    let pageInfo = results.data?.metaobjects?.pageInfo
    if (pageInfo?.hasNextPage) {
      query = getStoreQuery('eyewear_store', 250, pageInfo.endCursor)
      makeRequest((results) => {
        window.eyewearStoresList = window.eyewearStoresList.concat(results.data?.metaobjects?.edges?.map((edge) => formatStoreData('eyewear_store', edge)))
      }, query)
    }
  }, query)
}

export const setupEyewearStoresList = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    const swiperElement = dom.section.querySelector(`[${qs.swiper}]`)

    new Swiper(swiperElement, {
      autoplay: {
        delay: 5000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    })

    getStores()
    // dom.input.addEventListener('input', (e) => {
    //   state.fuse = new Fuse(window.eyewearStoresList, fuseOptions)
    //   const results = state.fuse.search(e.target.value.trim().toLowerCase())
    //   dom.regionSelector.value = ''
    //   window.setEyewearStoreResults(results, 0.1)
    // })
    dom.regionSelector.addEventListener('change', () => {
      dom.input.value = ''
      state.fuse = new Fuse(window.eyewearStoresList, {
        includeScore: true,
        keys: [{ name: 'region' }],
        useExtendedSearch: true,
      })
      let results = state.fuse.search(`=${dom.regionSelector.value?.replace(' ', '|')}`)
      window.setEyewearStoreResults(
        results,
        0.2,
        window.regionImages.filter((region) => region.name == dom.regionSelector.value)[0]?.image,
      )
      setTimeout(() => {
        window.scrollTo({
          top: dom.listWrap.offsetTop - 120,
          left: 0,
          behavior: 'smooth',
        })
      }, 100)
      // dom.reverseSection.classList.add('hidden')
    })
    dom.viewAll.forEach((viewAll) => {
      viewAll.addEventListener('click', () => {
        dom.input.value = ''
        dom.regionSelector.value = ''
        window.setEyewearStoreResults([])
        setTimeout(() => {
          window.scrollTo({
            top: dom.listWrap.offsetTop - 120,
            left: 0,
            behavior: 'smooth',
          })
        }, 100)
      })
    })
    dom.current.forEach((current) => {
      current.addEventListener('click', () => {
        fetch('https://ipinfo.io/json')
          .then((res) => res.json())
          .then((res) => {
            console.log(res)
            if (res.city) {
              state.fuse = new Fuse(window.eyewearStoresList, {
                includeScore: true,
                keys: [{ name: 'city' }],
              })
              let results = state.fuse.search(res.city.toLowerCase()).filter((result) => result.score <= 0.05)

              if (results.length == 0) {
                state.fuse = new Fuse(window.eyewearStoresList, {
                  includeScore: true,
                  keys: [{ name: 'zipcode' }],
                })
                results = state.fuse.search(res.postal.toLowerCase()).filter((result) => result.score <= 0.05)
                if (results.length == 0) {
                  state.fuse = new Fuse(window.eyewearStoresList, {
                    includeScore: true,
                    keys: [{ name: 'country' }],
                    useExtendedSearch: true,
                  })
                  results = state.fuse.search(`=${state.countries[res.country]?.replace(' ', '|')}`)

                  window.setEyewearStoreResults(results, 0.2)
                } else {
                  window.setEyewearStoreResults(results, 0.1)
                }
              } else {
                window.setEyewearStoreResults(results, 0.1)
              }
            }
          })
      })
    })
  }
}
